import Helper from '@/resource/Helper';

const VARIANTS = { success: 'success', error: 'error', info: 'info', warning: 'warning' };

export function notify(vm, status, message) {
    const variant = status === false ? 'error' : VARIANTS[status];
    if (!variant || !message) return;
    Helper.infoMessage(vm, variant, String(message));
}

export function errorMessage(err) {
    return (err && err.response && err.response.data && err.response.data.message)
        || (err && err.data && err.data.message)
        || (err && err.message)
        || 'Something went wrong. Please try again.';
}

// 401/403 are handled by memberReviewApi (redirect to expired page), so no toast.
export function notifyError(vm, err) {
    const status = err && err.response && err.response.status;
    if (status === 401 || status === 403) return;
    notify(vm, 'error', errorMessage(err));
}
